import RewindQueueEntry from '../../../../types/api/rewind-queue-entry'
import { isRewindJobInProgress } from '../../../rewinder-machines-schedule/components/one-rewinder-machine/helpers/rewind-job-helpers'

export function canMoveRewindQueueEntry(entry: RewindQueueEntry): boolean {
    return !isRewindJobInProgress(entry.rewind_job)
}
